import { Trans } from "@/framework/plugins/translation";
import EmptyRouterView from "../views/EmptyRouterView.vue";
import {
  checkActivationStart,
  checkAppInitial,
  checkIsAdmin,
  checkIsStaff,
  checkNeedInitialize,
  conversationGuard,
  proceedToHotelAdminFunction,
} from "./guards";
import CouponRoutes from "@/modules/coupon/CouponRoutes";

function load(component: string) {
  // '@' is aliased to src/components
  return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`);
}

export default [
  {
    path: "/home",
    meta: { layout: "no-header" },
    name: "root_home",
    component: load("Home"),
  },
  {
    path: "/voice-chat-test",
    meta: { layout: "no-header" },
    name: "voice_chat_test",
    component: load("VoiceChatTest"),
  },
  {
    path: "/voice-chat-test/:session_id",
    meta: { layout: "no-header" },
    name: "voice_chat_test_with_session",
    component: load("VoiceChatTest"),
  },
  {
    path: "/signin",
    meta: { layout: "no-header" },
    name: "root_signin",
    component: load("Proxy"),
  },
  {
    path: "/hotel_start",
    name: "hotel_start",
    meta: { layout: "no-header" },
    component: load("admin/HotelStart"),
  },
  {
    path: "/hotel_lang",
    name: "hotel_lang",
    meta: { layout: "no-header" },
    component: load("admin/HotelLang"),
  },
  {
    path: "/proxy/:target",
    meta: { layout: "no-header" },
    name: "proxy_1_params",
    component: load("Proxy"),
  },
  {
    path: "/proxy/:target/:value",
    meta: { layout: "no-header" },
    name: "proxy_2_params",
    component: load("Proxy"),
  },
  {
    path: "/proxy/:target_class/:target_action/:value1/:value2",
    meta: { layout: "no-header" },
    name: "proxy_4_params",
    component: load("Proxy"),
  },
  {
    path: "/proxy/:target_class/:target_action/:value1/:value2/:value3",
    meta: { layout: "no-header" },
    name: "proxy_5_params",
    component: load("Proxy"),
  },
  {
    path: "/adobe_dc_view",
    meta: { layout: "no-header" },
    name: "adobe_dc_view",
    component: load("AdobeDcView"),
  },
  {
    path: "/dev_tool/:any_path",
    name: "developer's tool",
    meta: { layout: "no-header" },
    component: load("dev_tool/DevTool"),
  },
  {
    path: "/:lang",
    component: EmptyRouterView,
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: "",
        meta: { layout: "no-header" },
        name: "home",
        component: load("Home"),
      },
      {
        path: "hotel_admin_function",
        name: "hotel_admin_function",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminFunction"),
        // component: load("apolloSample/ApolloSample")
      },
      {
        path: "hotel_admin_restriction",
        name: "hotel_admin_restriction",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminRestriction"),
      },
      {
        path: "hotel_admin_ai",
        name: "hotel_admin_ai",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminAI"),
      },
      {
        path: "hotel_admin_room",
        name: "hotel_admin_room",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminRoom"),
      },
      {
        path: "hotel_admin_member",
        name: "hotel_admin_member",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/AccountSetting/HotelAdminMember"),
      },
      {
        path: "hotel_admin_group",
        name: "hotel_admin_group",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/AccountSetting/HotelAdminGroup"),
      },
      {
        path: "hotel_admin_admin_staff",
        name: "hotel_admin_admin_staff",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/AccountSetting/HotelAdminAdminStaff"),
      },
      {
        path: "hotel_admin_login_status",
        name: "hotel_admin_login_status",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/AccountSetting/HotelAdminLoginStatus"),
      },
      {
        path: "hotel_admin_responder",
        name: "hotel_admin_responder",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/AccountSetting/HotelAdminResponder"),
      },
      {
        path: "hotel_admin_design",
        name: "hotel_admin_design",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminDesignSetting"),
      },
      {
        path: "hotel_admin_system_message",
        name: "hotel_admin_system_message",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminSystemMessageSetting"),
      },
      {
        path: "hotel_admin_main_menu_icon",
        name: "hotel_admin_main_menu_icon",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminMainMenuIconTool"),
      },
      {
        path: "hotel_admin_payment_gmo_setting",
        name: "hotel_admin_payment_gmo_setting",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminPaymentGmoSetting"),
      },
      {
        path: "hotel_admin_pms_setting",
        name: "hotel_admin_pms_setting",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminPmsSetting"),
      },
      {
        path: "user_dictionary",
        name: "translation_result_edit",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/dictionary/UserDictionary"),
      },
      {
        path: "unique_words_setting",
        name: "unique_words_setting",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/dictionary/UniqueWordsSetting"),
      },
      {
        path: "import_dictionary",
        name: "import",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/dictionary/ImportDictionary"),
      },
      {
        path: "hotel_admin_inquiry_history",
        name: "hotel_admin_inquiry_history",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/History/HotelAdminInquiryHistory"),
      },
      {
        path: "admin-operation-history",
        name: "admin-operation-history",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/History/HotelAdminOperationHistory"),
      },
      {
        path: "hotel_admin_bot/:mainMenuId/:subMenuId",
        name: "hotel_admin_bot",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminSubMenu"),
      },
      {
        path: "cs_admin_calendar/:mainMenuId/:subMenuId",
        name: "cs_admin_calendar",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminCalendar"),
      },
      {
        path: "signin",
        name: "signin",
        meta: { layout: "no-header" },
        component: load("Signin"),
      },
      {
        path: "signin/confirm",
        name: "confirm_signin",
        meta: { layout: "back-no-bottom" },
        component: load("common/ConfirmSignin"),
      },
      ...CouponRoutes,
      {
        path: "signin/admin/confirm",
        name: "confirm_admin_signin",
        meta: { layout: "back-no-bottom" },
        component: load("common/ConfirmSignin"),
      },
      {
        path: "signin/admin/:tenantCd",
        name: "signin_tenant",
        meta: { layout: "no-header" },
        component: load("admin/AdminSignin"),
      },
      {
        path: "signin/admin",
        name: "signin_admin",
        meta: { layout: "no-header" },
        beforeEnter: proceedToHotelAdminFunction,
        component: load("admin/AdminSignin"),
      },
      {
        path: "confirm",
        name: "confirm",
        meta: { layout: "default" },
        component: load("Confirm"),
      },
      {
        path: "system/disabled",
        name: "system_disabled",
        meta: { layout: "no-header" },
        component: load("SystemDisabled"),
      },
      // これもいらなくないですか...。
      // {
      //   path: "users",
      //   name: "users",
      //   beforeEnter: checkSignin,
      //   component: load("Users")
      // },
      {
        path: "conversations",
        name: "conversations",
        meta: { layout: "default" },
        beforeEnter: checkAppInitial,
        component: load("Conversations"),
      },
      {
        path: "conversation/:conversationId",
        meta: { layout: "no-back-no-bottom" },
        name: "conversation",
        beforeEnter: conversationGuard,
        component: load("Conversation"),
      },
      {
        path: "smsmenu",
        name: "smsmenu",
        beforeEnter: checkAppInitial,
        component: load("SmsMenu"),
      },
      {
        path: "translation",
        name: "translation",
        meta: { layout: "default" },
        beforeEnter: checkAppInitial,
        component: load("Translation"),
      },
      {
        path: "translation/interactive",
        meta: { layout: "back-no-bottom" },
        name: "translation_interactive",
        beforeEnter: checkAppInitial,
        component: load("TranslationInteractive"),
      },
      {
        path: "start_conversation/:userId",
        meta: { layout: "no-header" },
        name: "start_conversation",
        component: load("Startconversation"),
      },
      {
        path: "settings",
        name: "settings",
        meta: { layout: "default" },
        beforeEnter: checkAppInitial,
        component: load("Settings"),
      },
      {
        path: "username",
        meta: { layout: "back-no-bottom" },
        name: "username",
        beforeEnter: checkAppInitial,
        component: load("SetUserName"),
      },
      {
        path: "email/change",
        meta: { layout: "back-no-bottom" },
        name: "change_email",
        beforeEnter: checkAppInitial,
        component: load("ChangeEmail"),
      },
      {
        path: "email/confirm",
        meta: { layout: "back-no-bottom" },
        name: "confirm_email",
        beforeEnter: checkAppInitial,
        component: load("ConfirmEmail"),
      },
      /*
      {
        path: "notification",
        meta: { layout: "back-no-bottom" },
        name: "notification",
        beforeEnter: checkAppInitial,
        component: load("SetNotification"),
      },
      */
      {
        path: "mode",
        meta: { layout: "back-no-bottom" },
        name: "mode",
        beforeEnter: checkAppInitial,
        component: load("SetMode"),
      },
      {
        path: "maxHandlingGuest",
        meta: { layout: "back-no-bottom" },
        name: "maxHandlingGuest",
        beforeEnter: checkAppInitial,
        component: load("SetMaxHandlingGuest"),
      },
      {
        path: "myLanguages",
        meta: { layout: "back-no-bottom" },
        name: "myLanguages",
        beforeEnter: checkAppInitial,
        component: load("SetLanguageToBeSpoken"),
      },
      {
        path: "languages",
        meta: { layout: "back-no-bottom" },
        name: "languages",
        beforeEnter: checkAppInitial,
        component: load("Languages"),
      },
      {
        path: "activation/:userId",
        name: "activation",
        meta: { layout: "no-header" },
        beforeEnter: checkActivationStart,
        component: load("Startconversation"),
      },
      {
        path: "group/members/edit/:groupId",
        name: "group_members_edit",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkAppInitial,
        component: load("staff/P2P/GroupMembersEdit"),
      },
      {
        path: "group/members/:groupId",
        name: "group_members",
        meta: { layout: "back-no-bottom" },
        component: load("staff/P2P/GroupMembersView"),
      },
      {
        path: "group/profile/:groupId",
        name: "group_profile",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkAppInitial,
        component: load("staff/P2P/GroupProfile"),
      },
      {
        path: "group/join/:groupId",
        name: "group_join",
        meta: { layout: "back-no-bottom" },
        component: load("staff/P2P/GroupJoin"),
      },
      {
        path: "group/join/:groupId/:inviteUserId",
        name: "group_join_invite",
        meta: { layout: "back-no-bottom" },
        component: load("GroupJoin"),
      },
      {
        path: "group/notification/:groupId",
        name: "set_notification_range",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkAppInitial,
        component: load("SetNotificationRange"),
      },
      {
        path: "initial",
        name: "initial",
        meta: { layout: "no-header" },
        beforeEnter: checkNeedInitialize,
        component: load("FirstSelection"),
      },
      {
        path: "migration/email",
        name: "migration_email",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkNeedInitialize,
        component: load("AccountMigrationInputEmail"),
      },
      {
        path: "migration/pin",
        name: "migration_pin",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkNeedInitialize,
        component: load("AccountMigrationInputPin"),
      },
      {
        path: "biz/staff/inquiry/:inquiryId",
        name: "inquiry",
        meta: { layout: "staff-notification" },
        beforeEnter: checkIsStaff,
        component: load("cs/inquiry/InquiryParent"),
      },
      {
        path: "biz/staff/login/status",
        name: "login_status",
        meta: { layout: "default" },
        beforeEnter: checkIsStaff,
        component: load("staff/StaffLoginStatus"),
      },
      {
        path: "biz/staff/forward/group",
        name: "forward_group",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkIsStaff,
        component: load("staff/StaffForwardGroup"),
      },
      {
        path: "biz/staff/forward/group/:groupId/members",
        name: "forward_member",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkIsStaff,
        component: load("staff/StaffForwardMember"),
      },
      {
        path: "biz/staff/join/:tenantCode/:secretKey",
        name: "join_staff",
        meta: { layout: "no-header" },
        component: load("staff/StaffJoin"),
      },
      {
        path: "tutorial",
        name: "tutorial",
        meta: { layout: "no-header" },
        component: load("Tutorial"),
      },
      {
        path: "tutorial/w",
        name: "tutorial_w",
        meta: { layout: "no-header" },
        component: load("TutorialWrapper"),
      },
      {
        path: "card/list",
        name: "card_list",
        meta: { layout: "back-no-bottom" },
        beforeEnter: checkAppInitial,
        component: load("CardList"),
      },
      {
        path: "subscription/test",
        name: "subscription_test",
        meta: { layout: "default" },
        beforeEnter: checkAppInitial,
        component: load("SubscriptionTest"),
      },
      {
        path: "sandbox",
        name: "sandbox",
        meta: { layout: "no-header" },
        component: load("admin/sandbox/SandboxHome"),
      },
      {
        path: "apply_to_production",
        name: "apply_to_production",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/HotelAdminApplyToProduction"),
      },

      {
        path: "hotel_admin_client_chat_setting",
        name: "hotel_admin_client_chat_setting",
        meta: { layout: "hotel-admin" },
        beforeEnter: checkIsAdmin,
        component: load("admin/client_chat/HotelAdminClientChatSetting"),
      },
      {
        path: "*",
        component: load("404"),
      },
    ],
  },
  {
    // Redirect user to supported lang version.
    path: "*",
    // @ts-ignore
    redirect(to) {
      return Trans.getUserSupportedLang();
    },
  },
];
